<template>
  <div class="fondoHome">
    <router-link to="/"></router-link>
    <!-- <router-view v-slot="{ Component }">
      <transition name="fade">
        <component :is="Component" />
      </transition>
    </router-view> -->
    <router-view></router-view>
    <modalAlert />
    <!-- <transition name="fade"> -->
      <!-- <div class="fondo_transparente" v-show="modalVisible"/> -->
    <!-- </transition> -->
    <!-- <modalAlert
      :params = params
      v-show="modalVisible"
      @close="closeModal"
    />  /////////////////////////////////////////////////-->
  </div>
</template>

<script>
import modalAlert from '@/components/modalAlertIA.vue'
import { mapState } from 'vuex'
export default {
  components: { modalAlert },
  name: 'App',
  data () {
    return {
      // modalVisible: false,  /////////////////////////////
      transicionSel: '',
      params: {}
      // modo: 'in-out'
    }
  },
  created () {
    // this.emitter.on('my-event', evt => {
    //   this.modalVisible = evt.open
    //   this.params = evt
    // }) ////////////////////////////////////////////////////////////
    this.checkTokenExp() // función para verificar si el token de sesión ha expirado
    this.periodicCheckToken = setInterval(this.checkTokenExp, 300000) // Ejecución periódica de la función
  },
  unmounted () {
    clearInterval(this.periodicCheckToken)
  },
  methods: {
    // closeModal () {
    //   this.modalVisible = false
    // }, //////////////////////////////////////////////////////////
    checkTokenExp () {
      const expSession = this.usuarioEnSesion.expiraToken
      // console.log('Revisión de expiración')
      if (expSession < new Date()) {
        this.alertJoa('Ha expirado tu sesión, por favor ingresa nuevamente', 'W')
        this.$store.commit('doLogout')
        this.$router.push('/')
      }
    }
  },
  watch: {
    '$route' (to, from) {
      // this.transicionSel = to.path === '/page2' ? 'toggle' : 'fade'
      // if (to.path === '/page2') {
      //   this.transicionSel = 'toggle'

      // if (from.path === '/page2') {
      //   this.transicionSel = 'toggle'
      // } else {
      //   this.transicionSel = 'fade'
      // }
    }
  },
  computed: {
    ...mapState(['usuarioEnSesion'])
  }
}
</script>

<style>

@import url('assets/CSS/ico_sve.css');
@font-face {
    font-family:"ErasMD";
    src: url("./assets/FONTS/erasmd-webfont.woff2");
    src: url("./assets/FONTS/erasmd-webfont.woff");
}
@font-face {
    font-family:"ErasLT";
    src: url("./assets/FONTS/eraslt-webfont.woff2");
    src: url("./assets/FONTS/eraslt-webfont.woff");
}
@font-face {
    font-family:"OpenL";
    src: url("./assets/FONTS/opensans-light-webfont.woff2");
    src: url('./assets/FONTS/opensans-light-webfont.woff');
}
@font-face {
    font-family:"SegoeL";
    src: url("./assets/FONTS/segoeuil-webfont.woff2");
    src: url('./assets/FONTS/segoeuil-webfont.woff');
}
@font-face {
    font-family:"SegoeB";
    src: url("./assets/FONTS/seguibl-webfont.woff2");
    src: url('./assets/FONTS/seguibl-webfont.woff');
}
@font-face {
    font-family:"SegoeBI";
    src: url("./assets/FONTS/segoeuiz-webfont.woff2");
    src: url('./assets/FONTS/segoeuiz-webfont.woff');
}

.fondo_transparente{
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.3);
    position: absolute;
    height: 100vh;
    width: 100%;
    display: block;
    overflow: hidden;
 }

#app {
  font-family: Segoe, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color:white;
}
.fondoHome{
    background-image: url("./assets/fondos/FondoPrincipalTopoAzul.jpg");
    /* background-color: #2c3e50; */
    background-size: cover;
    /* position: fixed; */
    position: absolute;
    top: 0;
    left: 0;
    /* bottom: 0; */
    /* right: 0; */
    background-position: 35% 0% ;
    background-repeat: no-repeat;
    background-attachment: fixed;
    /* background-size: cover; */
    height: 100vh;
    width: 100vw;
    overflow: hidden;
}
/* .container{
  height: 100vh;
  display: grid;
  grid-template-columns: 25% 50% 25%;
  grid-template-rows: 15% 65% 20%;
  color:white;
} */
.Blk-1 {
  border-right-color: teal ;
  /* border-right-width: 1px; */
  border-right-style: solid;
  border-bottom-color: teal ;
  border-bottom-width: 1px;
  border-bottom-style: solid;
}

.icoSima{
  /* border: solid 1px chartreuse; */
  text-align: center; /* Sí funciona para centrar el texto*/
  /* align-self: center;   no funciona para centrar el elemento en vertical*/
}
.Blk-9 {
margin: 0px;
}

#nav {
  height: 15vh;
  /* width: 100vw; */
  background-color: cornsilk;
  /* position: absolute; */
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
  text-decoration: none;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.toggle-enter-from, .toggle-leave-to {
  transform: translateY(100vh);
}
.toggle-enter-active, .toggle-leave-active {
  transition-duration: 1.5s;
  top:0;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.6s ease;
}
.containerCol {
  width: 80vw;
  height: 70vh;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  display: grid;
  grid-template-columns: 20% 1fr 20%;
  grid-template-rows: 33% 67%;
  color:white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana;
  justify-content: center;
  margin-top: 1%;
  border: none;
}
.containerCol .Blk_1{
  margin:0px;
  background-color: rgba(0, 75, 105, 0.5);
  border-top-left-radius: 5px;
}
.containerCol .Blk_2{
  margin: 0;
  background-color: rgba(76, 93, 100, 0.8);
  /* overflow-y: scroll; */
  padding: 10px 20px 10px 10px;
}
.containerCol .Blk_3{
  margin: 0;
  display: grid;
  color: white;
  height: 100%;
  background-color:rgba(0, 94, 117, 0.9);
  grid-template-rows: 20% 60% 20%;
  border-top-right-radius: 5px;
}
.containerCol .Blk_4{
  margin:0px;
  background-color: rgba(0, 75, 105, 0.5);
  border-bottom-left-radius: 5px;
}
.containerCol .Blk_5{
  margin:0px;
  background-color: #d0d8ddd8;
}
.containerCol .Blk_6{
  margin:0px;
  padding-top: 20%;
  display:grid;
  grid-template-rows: 15% 15% 15% 15%;
  justify-items: right;
  align-content:center;
  background-color:#d0d8ddd8;
  border-bottom-right-radius: 5px;
}
:root {
  --azul2: rgb(51, 83, 110);
  --az-ico: rgb(30, 85, 130);
  --na: rgb(251, 155, 82);
  --gr-fo-cam: rgb(248, 248, 248);
  --gr-fo-for: rgba(248, 247, 246, 0.9);
  --gr-fo-sho: rgba(251, 246, 234, 0.8);
  --bo-cam: solid 0.5px rgb(187, 186, 185);
  --gris3: rgba(243, 243, 243);
  --az-me-tr05: rgba(10, 90, 140, 0.5);
  --az-me-tr07: rgba(10, 90, 140, 0.7);
  --az-cl-tr08: rgba(72, 125, 178, 0.8);
  --tx-cam: rgb(10, 90, 140);
}
</style>
